import React, {useState} from "react";

// react router
import {useHistory} from 'react-router-dom';

// kendo
import {DropDownButton, DropDownButtonItem} from '@progress/kendo-react-buttons';

// multilingual
import {
    fsaLicenseViewKey,
    getLicensesKey,
    mainMessages
} from "../../assets/text/MultilingualText.js";
import {menuIcon} from "@progress/kendo-svg-icons";

export const HamburgerMenuCell = (props) => {
    const {
        localization,
        siteLanguageDefault,
    } = props;

    let history = useHistory();

    // Flags
    const [expiredFlag, setExpiredFlag] = useState(false);

    // Render Logic for Menu Options
    const onClickMenuButton = () => {
        let expired = props.dataItem.expired;
        setExpiredFlag(expired);
    };

    // Menu Styling
    const [opened, setOpened] = useState(false);
    const openedStyle = {
        padding: 0,
        color: "var(--keysight-secondary)"
    };
    const closedStyle = {
        padding: 0,
        color: "var(--color-text-prominent)"
    };
    const anchorAlign = {
        horizontal: "right",
        vertical: "top"
    };
    const popupAlign = {
        horizontal: "left",
        vertical: "top"
    };

    // Menu Option Click Handling
    const onItemClick = (e) => {
        let option = e.item.id
        if (option === "fsaLicenseView") {
            history.push('/fsa-detailed-view?fsa_id=' + props.dataItem.fsa_id)
        }
        else if (option === "getLicenses") {
            history.push('/fsa-request-license?fsa_id=' + props.dataItem.fsa_id)
        }
    }

    return (
        <td
            className="ksm-hamburger"
            style={opened ? openedStyle : closedStyle}
        >
            <DropDownButton
                svgIcon={menuIcon}
                fillMode={"flat"}
                rounded={null}
                opened={opened}
                popupSettings={{
                    animate: false,
                    popupClass: "ksm-hamburger-dropdown",
                    anchorAlign: anchorAlign,
                    popupAlign: popupAlign
                }}
                onItemClick={(event) => {onItemClick(event)}}
                onOpen={() => {
                    setOpened(!opened)
                    onClickMenuButton()
                }}
                onBlur={() => {setOpened(false)}}
            >
                <DropDownButtonItem
                    id={'fsaLicenseView'}
                    text={localization.toLanguageString(fsaLicenseViewKey, mainMessages[siteLanguageDefault][fsaLicenseViewKey])}
                />
                {!expiredFlag && (
                    <DropDownButtonItem
                        id={'getLicenses'}
                        text={localization.toLanguageString(getLicensesKey, mainMessages[siteLanguageDefault][getLicensesKey])}
                    />
                )}
            </DropDownButton>
        </td>
    )
}